import { render } from "./EditPet.vue?vue&type=template&id=84d4ad98&scoped=true"
import script from "./EditPet.vue?vue&type=script&lang=js"
export * from "./EditPet.vue?vue&type=script&lang=js"

import "./EditPet.vue?vue&type=style&index=0&id=84d4ad98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d4ad98"]])

export default __exports__